import { Fragment, ReactNode } from 'react';
import styled from 'styled-components';

import InfiniteScroll, {
  InfiniteScrollData,
} from '@/components/molecules/InfiniteScroll';
import ScrollTopStickyButton from '@/components/molecules/ScrollTopStickyButton';
import { BoardPostVo } from '@/types/community';

import EmptyPostList from './EmptyPostList';
import PostItem, { PostItemProps } from './PostItem';
import PostsSkeleton from './PostSkeleton';

interface Props extends Omit<PostItemProps, 'post'> {
  posts: InfiniteScrollData<Array<BoardPostVo>>;
  isSearchpage?: boolean;
  isVisibleMoveToTopButton?: boolean;
  emptyComponent?: ReactNode;
}

const PostList = ({
  posts,
  isMypage = false,
  isSearchpage = false,
  isVisibleMoveToTopButton = true,
  onClickPost,
  onClickReport,
  emptyComponent,
}: Props) => {
  if (posts.isLoading) return <PostsSkeleton />;
  if (!posts.isLoading && !posts.data?.length)
    return emptyComponent ? (
      <>{emptyComponent}</>
    ) : (
      <EmptyPostList isMypage={isMypage} isSearchpage={isSearchpage} />
    );

  return (
    <Container>
      <InfiniteScroll
        rootMargin={'0px 0px 0px 100px'}
        isLoading={posts.isLoading}
        hasNextPage={posts.hasNextPage}
        fetchNextPage={posts.fetchNextPage}
      >
        {posts.data?.map((post) => (
          <Fragment key={`post_${post.boardPostPid}`}>
            <PostItem
              post={post}
              isMypage={isMypage}
              onClickPost={onClickPost}
              onClickReport={onClickReport}
            />
          </Fragment>
        ))}
      </InfiniteScroll>
      {isVisibleMoveToTopButton && <ScrollTopStickyButton />}
    </Container>
  );
};

export default PostList;

const Container = styled.ul``;
